export default `vec4 p = vec4(p0/10., 1.);
    escape = 0.; p=abs(p);
    for(int i = 0; i < 8; i++){
      if(p.x > p.z)p.xz = p.zx;
      if(p.z > p.y)p.zy = p.yz;
      if(p.y > p.x)p.yx = p.xy;
      p*=(1.3/clamp(dot(p.xyz,p.xyz),0.1,1.));
      p.xyz-=vec3(.5,0.2,0.2);
    }
    float m = 1.5;
    p.xyz-=clamp(p.xyz,-m,m);
    return (length(p.xyz)/p.w)*10.;
  }`